import React, { useContext, useEffect, useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthContext from 'context/autentication/authContext';
import { Role } from "types/roles";
import { useHistory } from 'react-router-dom';

const RutaPrivada = ({ component: Component, roles, ...rest }) => {

    const authContext = useContext(AuthContext);
    const { usuarioAutenticado, rol, usuario } = authContext;
    const [state, setState] = useState()
    const history = useHistory();
    const checkToken = async (x) => {
        if (x) {
            if (x.status) {
                // 200 = logueado
                return x.status === 200
            }
        } else {
            return false
        }
    }

    useEffect(() => {
        clearCache().then(value => {

            if (value) { window.location.reload(true) }
        })
        //
        getPath(rest, Component)
        // eslint-disable-next-line
    }, []);
    function getDateFromLS() {
        let ls = {};
        if (global.localStorage) {
            try {
                ls = global.localStorage.getItem("lastReload") || null;
            } catch (e) {
                /*Ignore*/
            }
        }
        return ls ? ls : null;
    }

    function saveDateToLS(x) {
        if (global.localStorage) {
            global.localStorage.setItem(
                "lastReload",
                x
            );
        }
    }
    const clearCache = async () => {

        const lastReload = getDateFromLS()

        const DateNow = (new Date).getTime()
        if (!lastReload) {
            saveDateToLS(DateNow)
        } else {

            // 2days to clear cache
            if ((DateNow - lastReload) > 172800000) {

                saveDateToLS(DateNow)

                return true
            }
        }
        return false


    }

    const getPath = async (rest, Component, props) => {
        usuarioAutenticado().then(value => {
            checkToken(value).then(value => {
                setState(value)

            })
        });
        //setMisProps(<Component {...props} />)
    }

    useEffect(() => {
        if (!!usuario) {
            // Desactivamos aceptar termino y privacidad para todos los roles
            if (!!!usuario.terminosYCondicionesAceptados && !!!usuario.politicasDePrivacidadAceptadas && rol !== Role.Super ) {
                //history.push("/legales")
            }
        }
    }, [usuario])

    return (
        <Route {...rest} render={props => {
            if (state === false) {
                // 
                return (<Redirect to="/login" />)
            } else {
                if (roles && roles.indexOf(rol) === -1) {

                    if (rol === Role.Supervisor) {
                        return (<Redirect to={{ pathname: '/pantalla-policial' }} />)
                    }
                    if (rol === Role.Integrador) {
                        return (<Redirect to={{ pathname: '/clientes' }} />)
                    }
                    if (rol === Role.Super || rol === Role.Admin) {
                        return (<Redirect to={{ pathname: '/gateway' }} />)
                    }
                    //console.log("entre")
                    if (rol === Role.Admin || rol === Role.Soporte) {
                        return (<Redirect to={{ pathname: '/dashboard' }} />)
                    }
                } else {
                    //
                    return (<Component {...props} />)
                }
            }
        }} />
    );
}

export default RutaPrivada;